import { Modal, ModalBody, ModalHeader } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';

import { EndorsementsList } from '../EndorsementsList';

type Props = {
	isOpen: boolean;
	onClose: () => void;
	setIsOpen: (isOpen: boolean) => void;
};

export const EndorsementsModal: React.FC<Props> = ({ isOpen, onClose, setIsOpen }) => {
	const { translate } = useI18n();

	return (
		<div>
			<Modal isOpen={isOpen} onClose={onClose} onOpenChange={setIsOpen} className="z-10000" size="large">
				<ModalHeader
					title={translate('corgi.petition.details.endorsements.heading')}
					subtitle={translate('corgi.petition.details.endorsements.subheading')}
				/>

				<ModalBody className="pt-6">
					<EndorsementsList showAll />
				</ModalBody>
			</Modal>
		</div>
	);
};
